/** Test element for overflow */
const testElForOverflow = (el: Element) => {
  return [el.scrollWidth > el.clientWidth, el.scrollHeight > el.clientHeight];
};

export default testElForOverflow;
